export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00918.6736c56f.png";